import {useRef} from "react";
import {Box, Divider, Heading, Text,} from "@chakra-ui/react";
import LuminsTotals from "./Lumis";
import {useUser} from "../../core/hooks";
import {EU} from "../../constants/user/userEnum";
import Area from "./Lumis/Area";
import IlluminationAreas from "./Lumis/IlluminationAreas";

const Illumination = ({proposal, project, luminaire, setLuminaire}) => {
    const {user} = useUser()
    const reportTemplateRef = useRef(null);

    return (
        <Box ref={reportTemplateRef} minH='100vh'>
            <Box>
                <Heading fontSize="3xl" as="h2">
                    {user?.type === EU ? (<Text as='h2' m={0}>Illumination Reports</Text>) : (<Text as='h2' m={0}>Illumination Reports</Text>)}
                </Heading>
                <Text fontSize="md" mb={8}>
                    Explore how each upgrade will impact the lighting environment in the various areas of the project.
                </Text>
            </Box>
            <Divider my={4} oriantion="horisontal"/>
            <IlluminationAreas
                luminaire={luminaire}
                setLuminaire={setLuminaire}
                project={project}
                proposal={proposal}
            />
            {/*<Area*/}
            {/*    recentProposal={project}*/}
            {/*    key={project.id}*/}
            {/*    data={project}*/}
            {/*    areaName={project.title}/>*/}
        </Box>
    )
}

export default Illumination